import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, BrowserRouter as Router, Route, Link,useLocation } from "react-router-dom";
import "./componentCss/sidebar.css";
function AdminSidebar() {
  const closeSidebar = () => {
    document.body.classList.remove("sidebar-open"); // Removes the sidebar-open class
}
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.pathname);
  
  const [isCustomerDetailsOpen, setIsCustomerDetailsOpen] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  const [isAccountDetailsOpen, setIsAccountDetailsOpen] = useState(false);
  const [isStockDetailsOpen, setIsStockDetailsOpen] = useState(false);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(false);
  // Toggle function for Customer Details submenu
  const toggleCustomerDetails = () => setIsCustomerDetailsOpen(!isCustomerDetailsOpen);
  const toggleServiceDetails = () => setIsServiceOpen(!isServiceOpen);
  const toggleAccountDetails = () => setIsAccountDetailsOpen(!isAccountDetailsOpen);
  const toggleStockDetails = () => setIsStockDetailsOpen(!isStockDetailsOpen);
  const toggleReportDetails = () => setIsReportDetailsOpen(!isReportDetailsOpen);
  
  return (
    <aside className="main-sidebar sidebar-dark-light os-theme-dark elevation-4">
      <Link to={`/adminHome`} className="brand-link ">
        <span className="h4 font-weight-bold mx-2">Cable Tv Pay</span>
        <div className="d-flex justify-content-end">
                <i
                    className=" fas fa-bars py-1 d-md-none position-fixed top-0 end-0 z-index-5 mx-1 mt-1 text-bold text-light my-2"
                    onClick={closeSidebar}
                    aria-label="Close Sidebar"
                    style={{top: "10px",zIndex: 10}}/>
                </div>
      </Link>
      <div className="sidebar">
        <nav className="mt-1">
          <ul className="nav nav-pills nav-sidebar flex-column pt-3" data-widget="treeview" role="menu" data-accordion="false">  
            <li className="nav-item">
              <Link className="nav-link text-white" to={`/adminHome`}>
                <i className="nav-icon fas fa-home" />
                <p className="ms-2 font-truncate">Dashboard</p>
              </Link>
            </li>
           
            <li className="nav-item">
              <Link className="nav-link text-white" to={`/adminOperator`}>
                <i className="nav-icon fas fa-file-alt" />
                <p className="ms-2 font-truncate">Bill Generate</p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default AdminSidebar;
